import React, { useState } from "react";
import ChatbotButton from "./ChatbotButton";
import ChatWindow from "./ChatWindow";
import TutorialGuide from "../TutorialGuide/TutorialGuide";
import useQueryChatbotHistory from "../../api/chatbot/queries";
import useMutationAskQuestion from "../../api/chatbot/mutations";
import { useAuthDetailStore, useAuthStore } from "../../stores/useAuthStore";

const Chatbot = () => {
    const infos = useAuthStore((state) => state.infos);
    const detail = useAuthDetailStore((state) => state.detail);

    const [currentQuestion, setCurrentQuestion] = useState("");
    const { histories, isLoadingHistories } = useQueryChatbotHistory();
    const {
        data: newResponse,
        discussion,
        isLoading: isLoadingResponse,
        mutate,
    } = useMutationAskQuestion();

    const onAskQuestion = (question) => {
        setCurrentQuestion(question);
        return mutate(question);
    };

    // si non connecté, ne rien afficher
    if (!infos) {
        return null;
    }

    const has_chatbot_enabled = detail?.features?.chatbot?.activated;
    if (!has_chatbot_enabled) {
        return null;
    }

    return (
        <>
            <ChatbotButton />
            <ChatWindow
                newResponse={discussion}
                histories={histories}
                isLoading={isLoadingHistories}
                isLoadingResponse={isLoadingResponse}
                onAskQuestion={onAskQuestion}
                currentQuestion={currentQuestion}
            />
            <TutorialGuide />
        </>
    );
};

export default Chatbot;
